<template>
  <div class="animated fadeIn">
    <b-card>
      <b-card-header>
        <i class="icon-menu mr-1"></i>儲值紀錄
      </b-card-header>
      <b-card-body>
      <v-server-table :columns="columns" :data="data" :options="options" :theme="theme" ref="dataTable" id="dataTable">
        <a slot="user_id" slot-scope="props">{{props.row.Admin.firstname + ' ' + props.row.Admin.lastname}}</a>
        <a slot="super" slot-scope="props" class="d-inline-block text-center w-100"><span :class="props.row.super?'text-primary':'text-success'">{{props.row.super ? 'ALL' : 'SELF'}}</span></a>
        <a slot="valid" slot-scope="props" class="d-inline-block text-center w-100"><span :class="props.row.valid?'text-primary':'text-danger'">{{props.row.valid ? '是' : '否'}}</span></a>
        <!--<a slot="invoicetno" slot-scope="props" class="d-inline-block text-center w-100"><span :class="props.row.invoicetno?'text-primary':'text-danger'">{{props.row.invoicetno ? props.row.invoicetno : '未開發票'}}</span></a>-->
        <a slot="invoicetno" slot-scope="props" class="d-inline-block text-center w-100">
          <span v-if="props.row.invoicetno && props.row.invoicetno != 'AA00000000'" class="text-primary">{{props.row.invoicetno}}</span>
          <span v-else class="text-danger">
            <button :disable="!showReSendInvoiceModal" @click="resendInvoice(props.row)">重開發票</button>
          </span>
        </a>
        <a slot="name" slot-scope="props" class="d-inline-block text-center w-100">{{props.row.EndUser.name}}</a>
        <a slot="amount" slot-scope="props" class="d-inline-block text-right w-100">{{props.row.amount}}點 / NTD ${{props.row.amount * 1.15|dn}}</a>
        <a slot="phone" slot-scope="props" class="d-inline-block text-center w-100">{{props.row.EndUser.phone}}</a>
        <a slot="email" slot-scope="props" class="d-inline-block text-center w-100">{{props.row.EndUser.email}}</a>
        <a slot="email" slot-scope="props" class="d-inline-block text-center w-100">{{props.row.EndUser.email}}</a>
      </v-server-table>
      </b-card-body>
    </b-card>

    <b-modal title="發票處理中" v-model="showReSendInvoiceModal" :hide-footer="true" :hide-header="true" :no-close-on-esc="true" :no-close-on-backdrop="true">
      <h3>發票開立中，請稍候</h3>
    </b-modal>
    
  </div>
</template>

<script>
import Vue from 'vue'
import {ServerTable, Event} from 'vue-tables-2'
import { required, minLength, between, email, minValue, integer } from 'vuelidate/lib/validators'
import vSelect from 'vue-select'
import Multiselect from 'vue-multiselect'
import config from '@/config/global'
import notifications from '@/config/notifications'
import jQuery from 'jquery'
import select2 from 'select2'
import qrcode from 'qrcode'
import sha1 from 'sha1'
import _ from 'lodash'

const encrypt    = config.encrypt;
const decrypt    = config.decrypt;
const admin_root = config.admin_root;

const clean_form = {
  name:    '',
  url:     '',
  address: '',
  phone:   '',
  contact: '',
  idno:    '',
  remarks: '',
  super:   0
};

let $selec2 = null;

Vue.use(ServerTable)

export default {
  name: 'AddValues',
  notifications,
  components: {
    ServerTable,
    Event,
    Multiselect,
    vSelect
  },
  data(){
    let app = this;
    return {
      super_options: [
        {label:'可以看到全部公司資料', value:1},
        {label:'只能看到所屬公司資料', value:0}
      ],
      device_uri: '',
      showRegisterQrCode: false,
      showAdminQrCode: false,
      selected_row: null,
      isFindingLoading: false,
      editRowId: null,
      record: Object.assign({}, clean_form),
      showEditorModal: false,
      delRowShowModal: false,
      showReSendInvoiceModal: false,
      delRowId: 0,
      delRowMsg: '',
      adminlogin_uri: '',
      register_uri: '',
      columns: ['id', 'amount', 'name', 'phone', 'email', 'invoicetno','created'],
      data: [],
      options: {
        headings: {
          id: '交易序號',
          amount: '加值點數 / 加值金額',
          name: '姓名',
          phone: '電話',
          email: 'Email',
          invoicetno: '發票號碼',
          created: '時間'
        },
        orderBy: {
          column: 'created',
          ascending: false
        },
        sortable: ['name', 'invoicetno', 'id', 'created'],
        filterable: [],
        sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
        pagination: {
          chunk: 5,
          edge: false,
          nav: 'scroll'
        },
        perPage: 25,
        requestFunction(data) {
          
          let action = `${admin_root}/get_list/TransactionInOnly`;
          let params = {
            keyset: 'mqtt',
            token: app.$state.$get('adminuser').token
          };

          for(let col in data){
            params[col] = data[col];
          }

          return app.$jsonp(action, params);//return the Promise
        }//eo requestFunction
      },
      useVuex: false,
          theme: 'bootstrap4',
          template: 'default'
    };//eo return
  },//eo data

  methods: {

    editRow(row_id, row) {
      // console.info('edit row_id:', row_id);
      this.selected_row = row;
      this.openEditor(row_id);

      this.selected_row['serialno'] = row['sn'];

      if(this.selected_row['end_user_id'] == 0){
        this.selected_row['end_user_id'] = '';
      }

      this.selected_row['super'] = this.selected_row['super'] ? '可以看到全部公司資料' : '只能看到所屬公司資料';

      this.record = Object.assign({}, this.selected_row);
    },//eo editRow

    delRow(row_id, row_name) {
      // console.info('del row_id:', row_id);

      this.delRowShowModal = row_id ? true : false;
      this.delRowId        = row_id;
      this.delRowMsg       = `您確定要刪除${row_name}嗎？`;
    },//eo delRow

    chkState(val) {
        const field = this.$v.record[val];
        return !field.$dirty || !field.$invalid;
      },

      openEditor(row_id){
        this.editRowId       = row_id;
        this.showEditorModal = true;
        this.$v.$reset();

        let page_limit = 10;
        let app        = this;

        //workaround for select2 to be able to use search input
        jQuery('div.modal-content').removeAttr('tabindex');

        if(true){
          $selec2 = jQuery('.select2');

          // console.info('$end_user_selec2:', $end_user_selec2);

          if($selec2.length){
            //init select2
            $selec2.select2({
              width: 'copy',
              dropdownAutoWidth: true,
              placeholder: '管理員專用選單項目',
              allowClear: true,
              data: [
                {id:0,text:'否'},
                {id:1,text:'是'}
              ]
            }).on('change', (event) => {
              app.record.is_admin = $selec2.select2('val');
            });
          }
        }

        //workaround for Bootstrap4
        if($selec2.data('select2')){
          $selec2.data('select2').$container.addClass("form-control");
        }

        if(row_id && app.selected_row){

          let value_object = app.selected_row.is_admin ? {id:1, text:'是'} : {id:0, text:'否'};

          $selec2.val(app.selected_row.is_admin).trigger('change');
          
          $selec2.trigger({
              type: 'select2:select',
              params: {
                data: value_object
              }
          });

          $selec2.val(value_object.id).trigger('change');
            
        } else {
          app.record       = Object.assign({}, clean_form);
          app.selected_row = null;
          app.row_id       = null;

          $selec2.val('').trigger('change'); 
        }
      },

      submitRecord() {

        let app    = this;
        let row_id = app.editRowId;

        this.$v.$touch();

        if (this.$v.$invalid) {
            this.showError({message:'請輸入必填欄位', title:'資料錯誤'});
            return false;
        }

        let to_save = this.record;

        if(row_id){
          to_save['id'] = row_id;
        }

        if(_.isObject(to_save['super'])){
          to_save['super'] = to_save['super']['value'] === 'all' ? 1 : 0;
        }

        // console.info('to_save:', to_save);

        to_save = encodeURIComponent(encrypt(JSON.stringify(to_save)));

        let action = `${admin_root}/save_record/Company`;
        let params = {
          keyset: 'mqtt',
          token:  this.$state.$get('adminuser').token,
          record: to_save
        };

        this.$jsonp(action, params).then((result) => {
          if(result.success){
            app.showSuccess({
              title: '成功',
              message: '資料成功儲存'
            });
            app.$refs['dataTable'].refresh();
            app.record = Object.assign({}, clean_form);
            app.$v.$reset();
          } else {
            app.showError({
              title: '錯誤',
              message: '無法儲存資料，請稍後再試'
            });
            app.$refs['dataTable'].refresh();
          }
        });
      },

      genAdminLoginRow(row_id) {
        this.showAdminQrCode = true;
        row_id               = encodeURIComponent(config.encrypt(''+row_id, config.ffkey, config.ffiv));

        let msg = `${config.frontend_entry}/#/_admin_?ccid=${row_id}`;
        qrcode.toCanvas(document.getElementById('adminlogin-qrcode-canvas'), msg);
        this.adminlogin_uri = msg;
      },//eo genAdminLoginRow

      genRegisterRow(row_id) {
        // console.info('row clicked: ', row_id);
        this.showRegisterQrCode = true;
        row_id                  = encodeURIComponent(config.encrypt(''+row_id, config.ffkey, config.ffiv));

        let msg = `${config.frontend_entry}/#/aregg?ccid=${row_id}`;
        qrcode.toCanvas(document.getElementById('register-qrcode-canvas'), msg);
        this.register_uri = msg;
      },//eo genAdminLoginRow

      resendInvoice(row) {
        let app    = this;
        let data = {
          id: row.id,
          user_id: row.EndUser.id,
          invoicetransno: row.invoicetransno
        };

        data = encodeURIComponent(encrypt(JSON.stringify(data)));

        let action = `${admin_root}/resend_invoice`;
        let params = {
          keyset: 'mqtt',
          token:  this.$state.$get('adminuser').token,
          data: data
        };

        app.showReSendInvoiceModal = true;

        this.$jsonp(action, params, 10000).then((result) => {
            if(result.success){
              app.showReSendInvoiceModal = false;
              app.showSuccess({
                title: '成功',
                message: '發票開立成功'
              });
              
              //app.$refs['dataTable'].refresh();
              const currentPage = app.$refs.dataTable.page;
              // 使用Vue.nextTick確保DOM更新完成
              app.$nextTick(() => {
                // 設置回之前的頁碼(此會重新請求數據)
                app.$refs.dataTable.setPage(currentPage);
              });
            } else {
              app.showReSendInvoiceModal = false;
              app.showError({
                title: '失敗',
                message: '發票開立失敗'
              });
              //app.$refs['dataTable'].refresh();
            }
          }).catch((error) => {
            app.showReSendInvoiceModal = false;
            app.showError({
              title: '錯誤',
              message: `發票開立錯誤。Error:${error}`
            });
            //app.$refs['dataTable'].refresh();
          });
        },

  },//eo methods

  validations: {
    record: {
      name: {
        required,
        minLength: minLength(2)
      }
    }
  },//eo validations
  
};
</script>
<style lang="scss">
.card-body{padding:0;}
.add-btn{}
.multiselect__input{width:100%;border:none;}
.qrcode-canvas{
  display:inline-block;
  margin: auto;
}
#dataTable {
  width: 95%;
  margin: 0 auto;
  margin-top: 0.5rem;
  font-size: 0.75rem;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .vue-title {
    text-align: center ;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }
  .VueTables__search-field input {
    margin-left: 0.25rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }

  .VueTables__child-row-toggler--open::before {
    content: "-";
  }

  .VueTables__sortable {
    padding: 0.25rem;
  }
}
</style>
